import React from "react";
import "./AttachmentSelectorTable.scss";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Radio,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import ReleaseTextIconMarked from "../../../VectorIcons/ReleaseTextIconMarked";
import ReleaseTextIcon from "../../../VectorIcons/ReleaseTextIcon";

const formatDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      })
    : "";

export function AttachmentSelectorTable({ attachments, selectedId, onSelect }) {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        width: "100%",
        bgcolor: "transparent",
        maxHeight: 510,
        padding: "16px 0px 16px 0px",
      }}
      className="ai-attachment-selector-table-container"
    >
      <Table
        size="small"
        aria-label="attachments"
        sx={{
          "& td, & th": {
            borderBottom: "none",
            py: "3px",
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell
              sx={{ width: "64px", paddingLeft: "14px", paddingRight: "14px" }}
              align="center"
            />

            <TableCell sx={{ width: "140px", paddingLeft: "0px" }}>
              <Typography
                variant="caption"
                sx={{ fontWeight: 700, letterSpacing: 0.8 }}
              >
                TIPO
              </Typography>
            </TableCell>

            <TableCell sx={{ width: "90px" }} align="center">
              <Typography
                variant="caption"
                sx={{ fontWeight: 700, letterSpacing: 0.8 }}
              >
                VERSÃO
              </Typography>
            </TableCell>

            <TableCell sx={{ maxWidth: "130px" }}>
              <Typography
                variant="caption"
                sx={{ fontWeight: 700, letterSpacing: 0.8 }}
              >
                ARQUIVO
              </Typography>
            </TableCell>

            <TableCell sx={{ width: "130px" }}>
              <Typography
                variant="caption"
                sx={{ fontWeight: 700, letterSpacing: 0.8 }}
              >
                RECEBIDO EM
              </Typography>
            </TableCell>

            <TableCell sx={{ width: "72px" }} align="center">
              <Typography
                variant="caption"
                sx={{ fontWeight: 700, letterSpacing: 0.8 }}
              >
                LIBERADO
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {attachments.map((att) => (
            <TableRow key={att.id}>
              <TableCell
                sx={{
                  width: "64px",
                  paddingLeft: "14px",
                  paddingRight: "14px",
                }}
                align="center"
              >
                <Radio
                  size="small"
                  checked={selectedId === att.id}
                  onChange={() => onSelect(att.id)}
                  value={att.id}
                  inputProps={{ "aria-label": att.fileName }}
                  sx={{
                    "&.Mui-checked": {
                      color: "#0098cd",
                    },
                  }}
                />
              </TableCell>

              <TableCell sx={{ paddingLeft: "0px" }}>
                <Typography variant="body2">{att.type.name}</Typography>
              </TableCell>

              <TableCell>
                <Typography align="center" variant="body2">
                  {`${att.version}ª`}
                </Typography>
              </TableCell>

              <TableCell>
                <Box sx={{ wordBreak: "break-all", whiteSpace: "normal" }}>
                  <Typography variant="body2" title={att.fileName}>
                    {att.fileName}
                  </Typography>
                </Box>
              </TableCell>

              <TableCell>
                <Typography variant="body2">
                  {formatDate(att.deliveryControl.completionDates.received)}
                </Typography>
              </TableCell>

              <TableCell align="center">
                {att.releaseManagement.channel ? (
                  <ReleaseTextIconMarked />
                ) : (
                  <ReleaseTextIcon color="#999999" />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
